<template>
    <div class="body">
        <div class="filter">
            <el-row :gutter="20" class="mb20">
                <el-col :span="3">
                    <div class="filter-col">
                        <label>时间段</label>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-col">
                        <el-date-picker
                                v-model="params.from"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :span="1">
                    <div style="height: 40px" class="flex-middle flex-center">~</div>
                </el-col>
                <el-col :span="6">
                    <div class="filter-col">
                        <el-date-picker
                                v-model="params.to"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </el-col>
                <div class="flex-end">
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                </div>
            </el-row>
        </div>
        <div class="data-box">
            <div class="list-box">
                <el-table
                        :data="list"
                        stripe
                        style="width: 100%">
                    <el-table-column
                            label="日志ID"
                            prop="id"
                            align="center"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            label="操作内容"
                            prop="message"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="创建时间"
                            prop="createTime"
                            align="center"
                            width="240">
                    </el-table-column>
                </el-table>

                <!--分页-->
                <div class="t_m m10">
                    <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            :current-page.sync="params.pageNum"
                            :page-size="params.pageSize"
                            layout="total, prev, pager, next"
                            :total="pageTotal">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SystemLog',
        data() {
            return {
                params: {
                    pageNum: 1,
                    pageSize: 10,
                    from: null,
                    to: null,
                },
                list: [],
                pageTotal: null,

            }
        },
        mounted(){
            this.fetchData()
        },
        methods: {

            handleCurrentChange(val) {
                this.params.pageNum = val
                this.fetchData()
            },

            handleSearch() {
                this.fetchData()
            },

            fetchData() {
                axios.get(Urls.URL.systemLog_url,{params:this.params}).then(res => {
                    if(res.status == '200') {
                        this.list = res.data.data.rows
                        this.pageTotal = res.data.data.count
                    }
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },
        }
    }
</script>

<style scoped lang="stylus">
    .body {
        width 100%
        height 100%
        padding-top 20px
    }

    .filter {
        padding 20px
        flex 1
        background-color white
        margin-bottom 20px
        >>>.el-col {
            height 40px
        }
        .filter-col {
            display flex
            align-items center
            height 100%
            >label {
                width 15%
                min-width 80px
            }
            >.el-input {
                flex 1
                min-width 120px
            }
            >.el-select {
                flex 1
                min-width 120px
            }
        }
    }

    .data-box {
        flex 1
        background-color white
        .modify-box {
            flex 1
            height 80px
            padding 0 20px
            display flex
            align-items center
            .modify-button {
                width 100px
            }
        }
        .list-box {
            flex 1
            padding 0 25px
        }
    }


    .mb20 {
        margin-bottom 20px
    }
</style>